module.exports = __webpack_public_path__ + "img/DSC_0073.51d17437.jpg";